export default __webpack_public_path__ + "static/media/product-enrichment-on-enterprise-nudge.a340b475.png";